<div class="header_search">
  <div class="title-page">
    <h3>Análise do Indicador</h3>
  </div>
  <div class="content_search">
    <div class="new-demand" *ngIf="analiseList?.length > 1">
      <button class="btn-back" type="btn" (click)="viewLast()">{{viewLastAnalises ? 'Ocultar' : 'Mostrar'}} Anteriores</button>
    </div>
    <div class="new-demand" *ngIf="getAnalise?.canCreateAnalysis">
      <a class="btn btn-primary" type="btn" [routerLink]="novo()" [queryParams]="novoParams()">Nova Análise</a>
    </div>
  </div>
</div>

<div class="system-table table-container">
  <div class="system-table-conteiner">
    <table>
      <thead>
        <tr>
          <th>Análise</th>
          <th class="text-center">Projeção para o ano</th>
          <th class="text-center">Atualização</th>
          <th class="text-center btn-icon-td">Ações</th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngFor="let analise of analiseList; let i = index">
          <tr *ngIf="analise?.last_one || viewLastAnalises">
            <td class="title">{{ analise?.description }}</td>
            <td class="text-center">
              <div>{{ analise?.goal }}</div>
              <div class="stat_analysis_id" *ngIf="analise?.ind_analysis_stat_id; else stat">
                <span *ngIf="analise?.ind_analysis_stat_id == 1" class="icon-system-Seta_cima"></span>
                <span *ngIf="analise?.ind_analysis_stat_id == 2" class="icon-system-Dificuldades"></span>
                <span *ngIf="analise?.ind_analysis_stat_id == 3" class="icon-system-Seta_baixo"></span>
              </div>
              <ng-template #stat>
                <div>
                  <span class="ind-status ind-status-0"></span>
                </div>
              </ng-template>
            </td>
            <td class="text-center">
              <div>{{ analise?.user }}</div>
              <div>{{ analise?.ctr_dth_atu }}</div>
            </td>
            <td class="btn-icon-td">
              <div class="btn-icon btn-icon-text">
                <a class="icon-table m-b-sm" [routerLink]="editar(analise?.id)" *ngIf="analise?.last_one && getAnalise?.canCreateAnalysis && getAnalise?.isFullBlocked">
                  <img src="assets/images/svgs/editar1.svg" alt="Editar" tooltip="Editar" placement="bottom">
                </a>
                <span class="icon-table icon-red m-b-sm" (click)="confirmExcluir(analise?.id)" *ngIf="analise?.last_one && getAnalise?.isFullBlocked && getAnalise?.canCreateAnalysis">
                  <img src="assets/images/svgs/trash.svg" alt="Excluir" tooltip="Excluir" placement="bottom">
                </span>
                <a class="icon-table icon-table-text" [routerLink]="novaDemandaLink()" [queryParams]="novaDemandaParams(analise?.id)" *ngIf="analise?.last_one && getAnalise?.canDemand">
                  Nova demanda
                </a>
              </div>
            </td>
          </tr>
        </ng-container>
        <tr *ngIf="!analiseList?.length" class="border-b-radius">
          <td colspan="4" class="text-center">Nenhuma Análise Cadastrada.</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
<app-loading [loader]="isLoading"></app-loading>
